import axios from "axios";
import { API_URL } from "../configs/apiUrls";
import { isEmpty } from "lodash";
export const SESSION_LOGIN = "SESSION_LOGIN";
export const SESSION_LOGOUT = "SESSION_LOGOUT";
export const LOGIN_REQUEST = "LOGIN_REQUEST";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILURE = "LOGIN_FAILURE";
export const HIDE_ERROR = "HIDE_ERROR";
export const HIDE_FEILD_VALIDATION_ERROR = "HIDE_FEILD_VALIDATION_ERROR";
export const TOKEN_EXPIRE = "TOKEN_EXPIRE";
export const CURRENT_PAGE_PERMISSIONS = "CURRENT_PAGE_PERMISSIONS";
export const HIDE_DISCLAIMER = "HIDE_DISCLAIMER";
export const SET_APPROVAL_NOTIFICATIONS = "SET_APPROVAL_NOTIFICATIONS";
export const SET_NOTIFICATIONS = "SET_NOTIFICATIONS";
export const SHOW_VARIFICATION_SCREEN = "SHOW_VARIFICATION_SCREEN";
export const RESET_SESSION = "RESET_SESSION";
export const SET_NOTIFICATION_REFRESH_TIME = "SET_NOTIFICATION_REFRESH_TIME";
export const SHOW_PASSWORD_RESET_SCREEN = "SHOW_PASSWORD_RESET_SCREEN";
export const REDIRECT_TO_LOGIN = "REDIRECT_TO_LOGIN";
export const STAY_ON_LOGIN = "STAY_ON_LOGIN";
const SHOW_LOADER = "SHOW_LOADER";
const HIDE_LOADER = "HIDE_LOADER";
export const SHOW_SNACKBAR = "SHOW_SNACKBAR";
export const HIDE_SNACKBAR = "HIDE_SNACKBAR";

const showCommonLoader = (label = "") => ({
  type: SHOW_LOADER,
  common_loder_label: label,
});
const hideCommonLoader = () => ({
  type: HIDE_LOADER,
});

export const setApprovalNotifications = (approval_notifications) => ({
  type: SET_APPROVAL_NOTIFICATIONS,
  approval_notifications: approval_notifications,
});

const setNotifications = (notifications) => ({
  type: SET_NOTIFICATIONS,
  notifications: notifications,
});

const setNotificationRefreshTime = (noti_refresh_time) => ({
  type: SET_NOTIFICATION_REFRESH_TIME,
  noti_refresh_time: noti_refresh_time,
});

export const login = () => (dispatch) =>
  dispatch({
    type: SESSION_LOGIN,
  });

export const logoutRequest = () => {
  return {
    type: SESSION_LOGOUT,
  };
};

const resetPasswordSuccess = (message) => ({
  type: SHOW_SNACKBAR,
  snackbar_notification: message,
  snackbar_notification_type: "success",
});

const resetPasswordFailure = (notification) => ({
  type: SHOW_SNACKBAR,
  snackbar_notification: notification,
  snackbar_notification_type: "general_error",
});

//password reset function
export const sendPasswordResetCode = (email, navigate) => {
  return (dispatch) => {
    dispatch(showCommonLoader());
    dispatch(loginRequest());
    return axios(API_URL + "sendPasswordResetCode", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      data: email,
    }).then(
      (response) => {
        dispatch(hideCommonLoader());
        dispatch(showVarificationScreen(response.data.user, true));
        //   dispatch(showPasswordResetScreen(response.data.user));
        navigate("/verification");
      },
      (error) => {
        dispatch(hideCommonLoader());
        handleErrorResponse(error, dispatch);
      }
    );
  };
};

const showPasswordResetScreen = (userObj, otp_code) => ({
  type: SHOW_PASSWORD_RESET_SCREEN,
  userObj: userObj,
  otp_code: otp_code,
  show_password_reset: true,
});

//CheckOTPCode

export const checkOTPcode = (user_id, verification_code) => {
  return (dispatch) => {
    dispatch(showCommonLoader());
    dispatch(loginRequest());
    return axios(API_URL + "checkOTPcode", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      data: {
        id: user_id,
        verification_code: verification_code,
      },
    }).then(
      (response) => {
        dispatch(hideCommonLoader());
        dispatch(
          showPasswordResetScreen(response.data.user, response.data.otp_code)
        );
        return {
          user: response.data.user,
          otp_code: response.data.otp_code,
        };
      },
      (error) => {
        dispatch(hideCommonLoader());

        // Display the API error as snackbar
        if (
          error.response &&
          error.response.data &&
          error.response.data.error
        ) {
          const errorMessage =
            typeof error.response.data.error === "string"
              ? error.response.data.error
              : Object.values(error.response.data.error).flat().join(", ");
          dispatch(resetPasswordFailure(errorMessage));
        }

        handleErrorResponse(error, dispatch);
      }
    );
  };
};

//password reset function
// In your actions
export const resetUserPassword = (data, navigate) => {
  return (dispatch) => {
    dispatch(showCommonLoader());
    dispatch(loginRequest());

    return axios(API_URL + "resetUserPassword", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      data: data,
    }).then(
      (response) => {
        dispatch(hideCommonLoader());
        dispatch(resetPasswordSuccess("Password updated Successfully"));
        dispatch(resetSessionState());

        // ✅ navigate will now work
        if (navigate) navigate("/login");
      },
      (error) => {
        dispatch(hideCommonLoader());
        dispatch(
          resetPasswordFailure(error.response.data.error.password.toString())
        );
        handleErrorResponse(error, dispatch);
      }
    );
  };
};

export const logout = () => {
  var token = localStorage.getItem("token");
  //clearInterval(window.tokenExpirationIntervalId); // Clear the interval here
  return (dispatch) => {
    return axios(API_URL + "logout", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Bearer " + token,
      },
    }).then(
      (response) => {
        localStorage.removeItem("token"); // Clear the token from local storage
        localStorage.removeItem("expiration_at"); // Clear the token from local storage
        dispatch(logoutRequest());
      },
      (error) => {
        localStorage.removeItem("token"); // Clear the token from local storage
        localStorage.removeItem("expiration_at"); // Clear the token from local storage
        dispatch(logoutRequest());
        handleNotificationsErrorResponse(error, dispatch);
      }
    );
  };
};

//setting current page permission in state
export const setCurrentPagePermissions = (current_page) => ({
  type: CURRENT_PAGE_PERMISSIONS,
  current_page: current_page,
});

const loginRequest = () => {
  return {
    type: LOGIN_REQUEST,
  };
};

const loginSuccess = (
  userObj,
  user_Permissions,
  user_permissions_raw,
  user_reporting,
  nested_menus,
  approval_notifications,
  shift_time,
  notifications
) => ({
  type: LOGIN_SUCCESS,
  payload: userObj,
  user_Permissions: user_Permissions,
  user_permissions_raw: user_permissions_raw,
  user_reporting: user_reporting,
  nested_menus: nested_menus,
  approval_notifications: approval_notifications,
  shift_time: shift_time,
  notifications: notifications,
});

const showVarificationScreen = (userObj, reset_password_flag = false) => {
  // Example if-else logic
  if (reset_password_flag === false) {
    return {
      type: SHOW_VARIFICATION_SCREEN,
      userObj: userObj,
      show_email_varification: true,
    };
  } else {
    return {
      type: SHOW_VARIFICATION_SCREEN,
      userObj: userObj,
      show_email_varification: true,
      reset_password_flag: true,
    };
  }
};

export const loginFailure = (error, errorType = "general") => ({
  type: LOGIN_FAILURE,
  payload: error,
  error_type: errorType,
});

const fetchNotificationsFailure = (notification) => ({
  type: SHOW_SNACKBAR,
  snackbar_notification: notification,
  snackbar_notification_type: "general_error",
});

const codeResendSuccess = (error) => ({
  type: LOGIN_FAILURE,
  payload: error,
  error_type: "message",
});

const validationError = (error) => ({
  type: LOGIN_FAILURE,
  payload: error,
  error_type: "validation",
});

export const resetSessionState = () => ({
  type: RESET_SESSION,
});

export const hideError = () => ({
  type: HIDE_ERROR,
});

export const hideFeildValidationError = (feild_key) => ({
  type: HIDE_FEILD_VALIDATION_ERROR,
  feild_key: feild_key,
});

export const userLoginFetch = (user, navigate) => {
  return (dispatch) => {
    dispatch(showCommonLoader());
    dispatch(loginRequest());

    const redirect_url = new URLSearchParams(window.location.search).get(
      "redirect_url"
    );

    return axios(API_URL + "login", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      data: {
        ...user,
        redirect_url: redirect_url || null,
      },
    }).then(
      (response) => {
        dispatch(hideCommonLoader());
        const redirect_url = new URLSearchParams(window.location.search).get(
          "redirect_url"
        );
        // return
        if (response.data.is_2fa_enable) {
          dispatch(showVarificationScreen(response.data.user));

          if (!isEmpty(redirect_url)) {
            navigate("/verification?redirect_url=" + redirect_url);
          } else {
            navigate("/verification");
          }
        } else {
          localStorage.setItem("token", response.data.access_token);
          localStorage.setItem("expiration_at", response.data.expiration_at);
          dispatch(
            loginSuccess(
              response.data.user,
              response.data.user_Permissions,
              response.data.user_permissions_raw,
              response.data.user_reporting,
              response.data.nested_menus,
              response.data.approval_notifications,
              response.data.shift_time
            )
          );
          dispatch(setNotifications(response.data.notifications));
          dispatch(setNotificationRefreshTime(response.data.noti_refresh_time));

          if (isEmpty(redirect_url)) {
            navigate("/dashboard");
          } else {
            let url = redirect_url + "?token=" + localStorage.getItem("token");
            return;
            setTimeout(function () {
              window.location.replace(url);
            }, 500);
          }
        }
      },
      (error) => {
        dispatch(hideCommonLoader());
        dispatch(loginFailure(error.response.data.error));
        handleErrorResponse(error, dispatch);
      }
    );
  };
};

export const verifyToken = (token, redirect_url = "") => {
  return (dispatch) => {
    //dispatch(loginRequest());
    dispatch(showCommonLoader());
    return axios(API_URL + "verify_token", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Bearer " + token,
      },
    }).then(
      (response) => {
        if (!isEmpty(redirect_url)) {
          let url = redirect_url + "?token=" + token;
          setTimeout(function () {
            window.location.replace(url);
          }, 500);
        }

        dispatch(hideCommonLoader());
      },
      (error) => {
        if (isEmpty(redirect_url)) {
          dispatch(loginFailure(error.response.data.error));
        }
        dispatch(hideCommonLoader());
      }
    );
  };
};

export const verifyEmailCode = (user_id, verification_code) => {
  return (dispatch) => {
    dispatch(showCommonLoader());
    return axios(API_URL + "verifyEmail", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      data: {
        id: user_id,
        verification_code: verification_code,
      },
    }).then(
      (response) => {
        localStorage.setItem("token", response.data.access_token);
        localStorage.setItem("expiration_at", response.data.expiration_at);
        dispatch(
          loginSuccess(
            response.data.user,
            response.data.user_Permissions,
            response.data.user_permissions_raw,
            response.data.user_reporting,
            response.data.nested_menus,
            response.data.approval_notifications,
            response.data.shift_time
          )
        );
        dispatch(setNotifications(response.data.notifications));
        dispatch(setNotificationRefreshTime(response.data.noti_refresh_time));
        dispatch(hideCommonLoader());
        return response.data.user; // Return the user data
      },
      (error) => {
        dispatch(hideCommonLoader());
        handleErrorResponse(error, dispatch);
        throw error; // Rethrow the error to handle it in the component if needed
      }
    );
  };
};

export const resendVerificationCode = (user_id) => {
  return (dispatch) => {
    //dispatch(loginRequest())
    dispatch(showCommonLoader());
    return axios(API_URL + "resendCode", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      data: {
        id: user_id,
      },
    }).then(
      (response) => {
        dispatch(codeResendSuccess("Code resend successfully"));
        //localStorage.setItem("token", response.data.access_token)
        //dispatch(showVarificationScreen(response.data.user));
        dispatch(hideCommonLoader());
      },
      (error) => {
        dispatch(hideCommonLoader());
        handleErrorResponse(error, dispatch);
      }
    );
  };
};

//Microsoft azure login functions
export const showMsalError = (err) => {
  return (dispatch) => {
    dispatch(loginFailure(err));
  };
};

export const loginWithMsal = (data) => {
  return (dispatch) => {
    dispatch(loginRequest());
    dispatch(showCommonLoader());
    return axios(API_URL + "loginWithMsal", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      data: {
        accessToken: data.accessToken,
        email: data.mail,
        userPrincipalName: data.userPrincipalName,
      },
    }).then(
      (response) => {
        localStorage.setItem("token", response.data.access_token);
        localStorage.setItem("expiration_at", response.data.expiration_at);
        dispatch(
          loginSuccess(
            response.data.user,
            response.data.user_Permissions,
            response.data.user_permissions_raw,
            response.data.user_reporting,
            response.data.nested_menus,
            response.data.approval_notifications,
            response.data.shift_time
          )
        );
        dispatch(setNotifications(response.data.notifications));
        dispatch(setNotificationRefreshTime(response.data.noti_refresh_time));
        dispatch(hideCommonLoader());
      },
      (error) => {
        dispatch(hideCommonLoader());
        handleErrorResponse(error, dispatch);
      }
    );
  };
};

//Disclaimer functions
export const hideDisclaimer = () => ({
  type: HIDE_DISCLAIMER,
});

// Get All Unread Notifications
export const getAllUnreadNotifications = (employee_id, timezone_id) => {
  return (dispatch) => {
    return axios(API_URL + "getAllUnreadNotifications", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      data: {
        employee_id: employee_id,
        timezone_id: timezone_id,
      },
    }).then(
      (response) => {
        dispatch(setNotifications(response.data));
      },
      (error) => {
        handleNotificationsErrorResponse(error, dispatch);
      }
    );
  };
};

// Read Notification Function
export const readNotification = (notification_id) => {
  return axios(API_URL + "readNotification", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    data: { id: notification_id },
  }).then(
    (response) => {},
    (error) => {}
  );
};

// Read All Notification Function
export const readAllNotifications = (employee_id) => {
  return axios(API_URL + "readAllNotifications", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    data: { employee_id: employee_id },
  }).then(
    (response) => {},
    (error) => {}
  );
};

// Get Notification Refresh Time
export const getNotiRefreshTime = () => {
  return (dispatch) => {
    return axios(API_URL + "settings/getNotificationRefreshTime", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    }).then(
      (response) => {
        dispatch(setNotificationRefreshTime(response.data));
      },
      (error) => {
        handleErrorResponse(error, dispatch);
      }
    );
  };
};

// export const userLoginFetch = (user, navigate) => {
//   return (dispatch) => {
//     dispatch(showCommonLoader());
//     dispatch(loginRequest());

//     const redirect_url = new URLSearchParams(window.location.search).get(
//       "redirect_url"
//     );

//     return axios(API_URL + "login", {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//         Accept: "application/json",
//       },
//       data: {
//         ...user,
//         redirect_url: redirect_url || null,
//       },
//     }).then(
//       (response) => {
//         dispatch(hideCommonLoader());
//         const redirect_url = new URLSearchParams(window.location.search).get(
//           "redirect_url"
//         );
//         // return
//         if (response.data.is_2fa_enable) {
//           dispatch(showVarificationScreen(response.data.user));

//           if (!isEmpty(redirect_url)) {
//             navigate("/verification?redirect_url=" + redirect_url);
//           } else {
//             navigate("/verification");
//           }
//         } else {
//           localStorage.setItem("token", response.data.access_token);
//           localStorage.setItem("expiration_at", response.data.expiration_at);
//           dispatch(
//             loginSuccess(
//               response.data.user,
//               response.data.user_Permissions,
//               response.data.user_permissions_raw,
//               response.data.user_reporting,
//               response.data.nested_menus,
//               response.data.approval_notifications,
//               response.data.shift_time
//             )
//           );
//           dispatch(setNotifications(response.data.notifications));
//           dispatch(setNotificationRefreshTime(response.data.noti_refresh_time));

//           if (isEmpty(redirect_url)) {
//             navigate("/dashboard");
//           } else {
//             let url = redirect_url + "?token=" + localStorage.getItem("token");
//             return;
//             setTimeout(function () {
//               window.location.replace(url);
//             }, 500);
//           }
//         }
//       },
//       (error) => {
//         dispatch(hideCommonLoader());
//         dispatch(loginFailure(error.response.data.error));
//         handleErrorResponse(error, dispatch);
//       }
//     );
//   };
// };
const handleErrorResponse = (error, dispatch) => {
  try {
    if (error.response.status === 422) {
      dispatch(validationError(error.response.data.error));
    } else {
      let err = "";
      if (error.response.data.error) {
        err = error.response.data.error.toString();
      } else {
        err = error.response.status + ` ` + error.response.statusText;
      }
      dispatch(loginFailure(err));
    }
  } catch (e) {
    dispatch(loginFailure("Unable to perform action.Something went wrong"));
  }
};

const handleNotificationsErrorResponse = (error, dispatch) => {
  try {
    if (error.response.status === 422) {
      dispatch(validationError(error.response.data.error));
    } else {
      let err = "";
      if (error.response.data.error) {
        err = error.response.data.error.toString();
      } else {
        err = error.response.status + ` ` + error.response.statusText;
      }
      dispatch(fetchNotificationsFailure(err));
    }
  } catch (e) {
    dispatch(
      fetchNotificationsFailure(
        "Unable to perform action. Something went wrong"
      )
    );
  }
};

const redirectToLogin = () => ({
  type: REDIRECT_TO_LOGIN,
});
export const stayOnLogin = () => ({
  type: STAY_ON_LOGIN,
});
